import { get } from './axios.js'

let api = '/api'

export const getNewsInfo = query => get(api + '/getArticleDetail?' + (query || ''))
